import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const ArrowForwardIosSharp = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z" />
  </IconSvg>
);

export default ArrowForwardIosSharp;
